import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "modal fade",
  id: "import-modal",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_2 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_3 = { class: "modal-content" }
const _hoisted_4 = /*#__PURE__*/_createStaticVNode("<div class=\"modal-header\"><div class=\"row w-100\"><div class=\"col-2 d-flex justify-content-center\"><div class=\"mr-4 symbol symbol-circle\"><span class=\"symbol-label btn-icon-white background_layout_1\"><i class=\"fas fa-print fs-3\" style=\"color:var(--cor_icones_1) !important;\"></i></span></div></div><div class=\"col-10 d-flex flex-grow-1\"><h3 class=\"card-title d-flex align-items-start flex-column\"><p class=\"card-label fw-bolder fs-4 mb-1\">Importar</p><p class=\"text-muted mt-1 fs-7 fw-light\">Importe seus dados de serviço facilmente</p></h3></div></div></div>", 1)
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "aviso" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Atenção! O envio de um arquivo com muitas linhas pode demorar alguns minutos, Aguarde...")
], -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__text fs-7" }, [
  /*#__PURE__*/_createTextVNode(" Solte o arquivo aqui ou clique para fazer o upload da planilha. "),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("em", { class: "fs-8 cor_texto_2" }, "Envie o arquivo em excel conforme os modelos de exemplo")
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "el-upload__tip" }, null, -1)
const _hoisted_9 = { class: "d-flex justify-content-between" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "Modelo para utilização para importação de serviços")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon-1 text-white indicator-label" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-download text-white" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, " Baixar ")
], -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = { class: "mt-3" }
const _hoisted_14 = { class: "d-flex justify-content-between" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "c d-flex align-items-center" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "fs-7" }, "Lista de códigos Descrição/Vídeo/Imagens")
], -1)
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "d-flex" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon-1 text-white indicator-label" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "fas fa-eye text-white" })
  ]),
  /*#__PURE__*/_createElementVNode("span", null, " Códigos ")
], -1)
const _hoisted_17 = [
  _hoisted_16
]
const _hoisted_18 = {
  class: "modal fade",
  id: "modalDescricao",
  tabindex: "-1",
  role: "dialog",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_19 = {
  class: "modal-dialog",
  role: "document"
}
const _hoisted_20 = { class: "modal-content" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", {
    class: "modal-title",
    id: "exampleModalLabel"
  }, " Codigos Descrição/Vídeo/Imagens: "),
  /*#__PURE__*/_createElementVNode("button", {
    type: "button",
    class: "btn-close",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×")
  ])
], -1)
const _hoisted_22 = {
  class: "modal-body p-0",
  style: {"overflow-x":"hidden","max-height":"500px"}
}
const _hoisted_23 = { class: "my-5 px-10" }
const _hoisted_24 = {
  rowhighlightclass: "ewTableHighlightRow",
  rowselectclass: "ewTableSelectRow",
  roweditclass: "ewTableEditRow",
  class: "table table-flush align-middle table-row-bordered table-row-solid gy-2 gx-3 gs-9"
}
const _hoisted_25 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("th", { class: "align-top text-muted" }, "COD"),
  /*#__PURE__*/_createElementVNode("th", { class: "align-top text-muted" }, "NOME PERSONALIZAÇÃO")
], -1)
const _hoisted_26 = { key: 0 }
const _hoisted_27 = {
  colspan: "12",
  class: "dataTables_empty"
}
const _hoisted_28 = { class: "text-nowrap" }
const _hoisted_29 = { class: "text-nowrap" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_empty = _resolveComponent("el-empty")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", null, [
              _hoisted_6,
              _createVNode(_component_el_upload, {
                class: "upload-demo",
                ref: "uploadRef",
                drag: "",
                action: "api/servico/importar/555",
                limit: 1,
                "auto-upload": false,
                accept: ".xlsx",
                onChange: _ctx.handleSuccess
              }, {
                tip: _withCtx(() => [
                  _hoisted_8
                ]),
                default: _withCtx(() => [
                  _hoisted_7
                ]),
                _: 1
              }, 8, ["onChange"])
            ]),
            _createElementVNode("div", null, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    class: "btn background_btn_1_opct text-white",
                    style: {"height":"32px","margin-left":"10px","padding-top":"5px","padding-bottom":"5px"},
                    onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.downloadReportTemplate()))
                  }, _hoisted_12)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createElementVNode("div", null, [
                  _createElementVNode("a", {
                    class: "btn background_btn_1_opct text-white",
                    style: {"height":"32px","margin-left":"10px","padding-top":"5px","padding-bottom":"5px"},
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showModalDescription()))
                  }, _hoisted_17)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.searchDescription,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchDescription) = $event)),
                placeholder: "codigo/nome"
              }, null, 8, ["modelValue"])
            ]),
            _createElementVNode("table", _hoisted_24, [
              _hoisted_25,
              _createElementVNode("tbody", null, [
                (_ctx.filterItemsDescription?.length == 0)
                  ? (_openBlock(), _createElementBlock("tr", _hoisted_26, [
                      _createElementVNode("td", _hoisted_27, [
                        _createVNode(_component_el_empty, { description: "Nenhum serviço foi encontrado" })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filterItemsDescription, (item, i) => {
                  return (_openBlock(), _createElementBlock("tr", { key: i }, [
                    _createElementVNode("td", _hoisted_28, [
                      _createElementVNode("div", null, _toDisplayString(item.codPersonalizacao), 1)
                    ]),
                    _createElementVNode("td", _hoisted_29, [
                      _createElementVNode("div", null, _toDisplayString(item.nomePersonalizacao), 1)
                    ])
                  ]))
                }), 128))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}